<svg
	xmlns="http://www.w3.org/2000/svg"
	[attr.class]="cssClass"
	[attr.viewBox]="getViewBox()"
	[style.height.px]="getSvgHeight()"
	[style.width.px]="getSvgWidth()">
	<ng-container>
		@switch (name) {
			<!-- User icon -->
			@case ('user') {
				<g>
					<path
						d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 10c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4z"
						fill="currentColor" />
				</g>
			}
			<!-- Loading spinner -->
			@case ('loading') {
				<g>
					<path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" fill="currentColor">
						<animateTransform
							attributeName="transform"
							attributeType="XML"
							dur="1s"
							from="0 12 12"
							repeatCount="indefinite"
							to="360 12 12"
							type="rotate" />
					</path>
				</g>
			}
			<!-- Error icon -->
			@case ('error') {
				<g>
					<path
						d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
						fill="currentColor" />
				</g>
			}
			<!-- Warning icon -->
			@case ('warning') {
				<g>
					<path d="M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z" fill="currentColor" />
				</g>
			}
			<!-- Info icon -->
			@case ('info') {
				<g>
					<path
						d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
						fill="currentColor" />
				</g>
			}
			<!-- Success/Check icon -->
			@case ('success') {
				<g>
					<path
						d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z"
						fill="currentColor" />
				</g>
			}
			<!-- Refresh icon -->
			@case ('refresh') {
				<g>
					<path
						d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
						fill="currentColor" />
				</g>
			}
			<!-- Empty state icon -->
			@case ('empty') {
				<g>
					<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" opacity="0.3" />
				</g>
			}
			<!-- Arrow right icon -->
			@case ('arrow-right') {
				<g>
					<path
						clip-rule="evenodd"
						d="M0 3.91304V6.08696L7.94444 6.08696L3.85185 10H7.7037L13 5L7.7037 0L3.85185 0L7.94444 3.91304L0 3.91304Z"
						fill="currentColor"
						fill-rule="evenodd" />
				</g>
			}
			<!-- Arrow down icon-16 -->
			@case ('arrow-down') {
				<g>
					<path d="m2 5 6 6 6-6" fill="none" stroke="currentColor" />
				</g>
			}
			<!-- Trash icon -->
			@case ('trash') {
				<g>
					<path
						d="m13.06884,1.31187c0,-0.59029 -0.47852,-1.06881 -1.06881,-1.06881c-0.59029,0 -1.06881,0.47852 -1.06881,1.06881l0,1.78135l-7.48169,0c-0.59029,0 -1.06881,0.47853 -1.06881,1.06881c0,0.59029 0.47852,1.06881 1.06881,1.06881l8.55051,0l8.55045,0c0.59032,0 1.06882,-0.47852 1.06882,-1.06881c0,-0.59028 -0.47851,-1.06881 -1.06882,-1.06881l-7.48164,0l0,-1.78135zm-9.01827,6.44474c0.20304,-0.2458 0.50522,-0.38813 0.82404,-0.38813l14.2508,0c0.31191,0 0.60819,0.13619 0.81123,0.37287c0.20304,0.23668 0.29263,0.55024 0.24525,0.85846l-2.19243,14.25079c-0.0803,0.52142 -0.52894,0.90634 -1.05648,0.90634l-9.31782,0c-0.51246,0 -0.95281,-0.36376 -1.04958,-0.86696l-2.74054,-14.25085c-0.06021,-0.31309 0.02249,-0.63671 0.22553,-0.88252zm2.11798,1.74949l2.32947,12.11319l7.51803,0l1.86359,-12.11319l-11.7111,0z"
						fill="currentColor" />
				</g>
			}
			<!-- File icon -->
			@case ('file') {
				<g>
					<path
						d="M18,22H6a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2h7.1a2,2,0,0,1,1.5.6l4.9,5.2A2,2,0,0,1,20,9.2V20A2,2,0,0,1,18,22Z"
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2" />
					<line
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						x1="7.9"
						x2="16.1"
						y1="17.5"
						y2="17.5" />
					<line
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						x1="7.9"
						x2="16.1"
						y1="13.5"
						y2="13.5" />
					<line
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						x1="8"
						x2="13"
						y1="9.5"
						y2="9.5" />
				</g>
			}
			<!-- External Link icon -->
			@case ('external-link') {
				<g>
					<path
						d="M12 6H7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-5m-6 0 7.5-7.5M15 3h6v6"
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2" />
				</g>
			}
			<!-- Copy icon -->
			@case ('copy') {
				<g>
					<path
						d="M3.06618 10.9788H2.27491C1.8552 10.9788 1.45268 10.812 1.1559 10.5153C0.859113 10.2185 0.692383 9.81596 0.692383 9.39625V2.27485C0.692383 1.85514 0.859113 1.45262 1.1559 1.15583C1.45268 0.859052 1.8552 0.692322 2.27491 0.692322H9.39631C9.81602 0.692322 10.2185 0.859052 10.5153 1.15583C10.8121 1.45262 10.9788 1.85514 10.9788 2.27485V3.06612"
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.38462" />
					<path
						d="M15.1111 6.40588H7.98976C7.11575 6.40588 6.40723 7.11441 6.40723 7.98842V15.1098C6.40723 15.9838 7.11575 16.6923 7.98976 16.6923H15.1111C15.9852 16.6923 16.6937 15.9838 16.6937 15.1098V7.98842C16.6937 7.11441 15.9852 6.40588 15.1111 6.40588Z"
						fill="none"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.38462" />
				</g>
			}
			<!-- Hide/Eye off icon -->
			@case ('hide') {
				<g>
					<path
						d="M12,2C13.73,2 15.4,2.4 16.92,3.17L15.5,4.59C14.41,4.21 13.24,4 12,4C7.5,4 3.91,7.09 3.09,11.2L1.11,9.22C2.24,5.82 6.74,2 12,2M12,22C10.27,22 8.6,21.6 7.08,20.83L8.5,19.41C9.59,19.79 10.76,20 12,20C16.5,20 20.09,16.91 20.91,12.8L22.89,14.78C21.76,18.18 17.26,22 12,22M12,6A6,6 0 0,1 18,12C18,12.78 17.83,13.53 17.53,14.21L16.12,12.8C16.05,12.54 16,12.27 16,12A4,4 0 0,0 12,8C11.73,8 11.46,8.05 11.2,8.12L9.79,6.71C10.47,6.37 11.22,6.2 12,6M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C1.73,16.39 6.24,20 12,20L16.73,24.73L18.73,22.73L4,2.27L2,4.27Z"
						fill="currentColor" />
				</g>
			}
			<!-- Show/Eye icon -->
			@case ('show') {
				<g>
					<path
						d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5Z"
						fill="currentColor" />
				</g>
			}
			<!-- Close icon -->
			@case ('close') {
				<g>
					<path
						d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
						fill="currentColor" />
				</g>
			}
			<!-- Menu-24 -->
			@case ('menu') {
				<g>
					<path d="m3 5h18v2h-18zm0 6h18v2h-18zm18 6h-18v2h18z" fill="currentColor" />
				</g>
			}
			<!-- User-18 -->
			@case ('user-18') {
				<g>
					<path
						d="M11.9439 9.49085C13.217 9.93013 14.3837 10.6558 15.364 11.636C17.0638 13.3359 18 15.596 18 18H16.5938C16.5938 13.8128 13.1872 10.4062 9 10.4062C4.81279 10.4062 1.40625 13.8128 1.40625 18H0C0 15.596 0.936176 13.3359 2.63605 11.636C3.61631 10.6558 4.78308 9.93013 6.05609 9.49085C4.69262 8.55179 3.79688 6.9802 3.79688 5.20312C3.79688 2.33413 6.131 0 9 0C11.869 0 14.2031 2.33413 14.2031 5.20312C14.2031 6.9802 13.3074 8.55179 11.9439 9.49085ZM5.20312 5.20312C5.20312 7.29675 6.90641 9 9 9C11.0936 9 12.7969 7.29675 12.7969 5.20312C12.7969 3.1095 11.0936 1.40625 9 1.40625C6.90641 1.40625 5.20312 3.1095 5.20312 5.20312Z"
						fill="currentColor" />
				</g>
			}
			<!-- User-24 -->
			@case ('user-24') {
				<g>
					<path
						d="m15.442 12.491c1.273.439 2.439 1.165 3.42 2.145 1.699 1.7 2.636 3.96 2.636 6.364h-1.407c0-4.187-3.406-7.594-7.593-7.594-4.188 0-7.594 3.407-7.594 7.594h-1.406c0-2.404.936-4.664 2.636-6.364.98-.98 2.147-1.706 3.42-2.145-1.364-.939-2.26-2.511-2.26-4.288 0-2.869 2.335-5.203 5.204-5.203s5.203 2.334 5.203 5.203c0 1.777-.896 3.349-2.259 4.288zm-6.741-4.288c0 2.094 1.703 3.797 3.797 3.797 2.093 0 3.796-1.703 3.796-3.797 0-2.093-1.703-3.797-3.796-3.797-2.094 0-3.797 1.704-3.797 3.797z"
						fill="currentColor" />
				</g>
			}
			<!-- Logout -->
			@case ('logout') {
				<g>
					<path
						clip-rule="evenodd"
						d="M4.21875 0C3.75163 0 3.375 0.378616 3.375 0.84375V5.90625C3.375 6.37338 3.75163 6.75 4.21875 6.75C4.68588 6.75 5.0625 6.37338 5.0625 5.90625V1.6875H16.3125V16.3125H5.0625V12.6562C5.0625 12.1891 4.68588 11.8125 4.21875 11.8125C3.75163 11.8125 3.375 12.1891 3.375 12.6562V17.1562C3.375 17.6234 3.75163 18 4.21875 18H17.1562C17.6234 18 18 17.6234 18 17.1562V0.84375C18 0.378616 17.6234 0 17.1562 0H4.21875ZM10.4179 4.73438C10.0893 4.40625 9.41004 4.40625 9.08191 4.73438C8.75379 5.0625 8.75379 5.74179 9.08191 6.06991L11.2412 8.4375H0.84375C0.378616 8.4375 0 8.81413 0 9.28125C0 9.74838 0.378616 10.125 0.84375 10.125H11.1386L9.27185 11.9981C8.94322 12.3014 8.90512 12.9818 9.2084 13.3104C9.51167 13.639 10.1921 13.6771 10.5207 13.3739L14.3207 10.0781C14.5026 9.91894 14.6166 9.54657 14.6244 9.177C14.6322 8.80744 14.5321 8.44759 14.2931 8.20859L10.4179 4.73438Z"
						fill="currentColor"
						fill-rule="evenodd" />
				</g>
			}
			<!-- Filter -->
			@case ('filter') {
				<g>
					<path
						d="m15.273 3h-1.637v5.727h1.637zm-12.273 1.636h9.818v1.637h-9.818zm6.545 6.546h11.455v1.636h-11.455zm3.273 6.545h-9.818v1.637h9.818zm3.273-13.091h4.909v1.637h-4.909zm-9 4.091h1.636v5.728h-1.636zm8.182 6.546h-1.637v5.727h1.637zm.818 2.454h4.909v1.637h-4.909zm-9.818-6.545h-3.273v1.636h3.273z"
						fill="currentColor" />
				</g>
			}
			<!-- World -->
			@case ('world') {
				<g>
					<path
						d="m18.364 5.636c-1.7-1.7-3.96-2.636-6.364-2.636s-4.664.936-6.364 2.636-2.636 3.96-2.636 6.364.936 4.664 2.636 6.364 3.96 2.636 6.364 2.636 4.664-.936 6.364-2.636 2.636-3.96 2.636-6.364-.936-4.664-2.636-6.364zm-8.071-1.396c-.302.294-.628.644-.954 1.051-.565.704-1.035 1.462-1.403 2.26h-2.516c1.124-1.657 2.856-2.868 4.873-3.311zm-5.476 4.365h2.701c-.307.919-.486 1.879-.533 2.868h-2.912c.067-1.02.327-1.988.744-2.868zm-.744 3.922h2.912c.047.989.226 1.949.533 2.868h-2.701c-.417-.88-.677-1.848-.744-2.868zm1.347 3.922h2.516c.368.797.838 1.556 1.403 2.26.326.407.652.757.954 1.051-2.017-.443-3.749-1.654-4.873-3.311zm6.053 2.962c-.376-.324-.843-.777-1.311-1.361-.41-.512-.761-1.046-1.054-1.601h2.365zm0-4.016h-2.84c-.343-.908-.541-1.866-.592-2.868h3.432zm0-3.922h-3.432c.051-1.002.249-1.959.592-2.868h2.84zm0-3.922h-2.365c.287-.544.629-1.067 1.028-1.569.475-.597.953-1.061 1.337-1.392zm8.454 3.922h-2.912c-.047-.989-.226-1.949-.533-2.868h2.701c.417.88.677 1.848.744 2.868zm-1.347-3.922h-2.516c-.368-.798-.838-1.556-1.402-2.26-.327-.407-.653-.757-.955-1.051 2.017.443 3.749 1.654 4.873 3.311zm-6.053-2.962c.376.324.843.777 1.312 1.361.409.512.76 1.046 1.053 1.601h-2.365zm0 4.016h2.84c.343.908.541 1.866.592 2.868h-3.432zm0 3.922h3.432c-.051 1.002-.249 1.96-.592 2.868h-2.84zm0 6.883v-2.961h2.365c-.287.544-.629 1.067-1.028 1.569-.475.597-.953 1.061-1.337 1.392zm1.18.35c.302-.294.628-.644.955-1.051.564-.704 1.034-1.462 1.402-2.26h2.516c-1.124 1.657-2.856 2.868-4.873 3.311zm5.476-4.365h-2.701c.307-.919.486-1.879.533-2.868h2.912c-.067 1.02-.327 1.988-.744 2.868z"
						fill="currentColor" />
				</g>
			}
			<!-- Chevron Right -->
			@case ('chevronRight') {
				<g>
					<path d="m18.5 55.329 23.329-23.329-23.329-23.329 1.671-1.671 25 25-25 25z" fill="currentColor" />
				</g>
			}
			<!-- Code File -->
			@case ('codeFile') {
				<g>
					<path
						d="M0 0V0.615385V15.3846V16H0.615385H11.6923H12.3077V15.3846V4.30769V4.05769L12.1346 3.86538L8.44231 0.173077L8.25 0H8H0.615385H0ZM1.23077 1.23077H7.38461V4.30769V4.92308H8H11.0769V14.7692H1.23077V1.23077ZM8.61538 2.11538L10.1923 3.69231H8.61538V2.11538ZM6.15385 6.15385L4.92308 13.5385H6.15385L7.38461 6.15385H6.15385ZM3.82692 7.61539L2.28846 9.46154L1.96154 9.84615L2.28846 10.2308L3.82692 12.0769L4.78846 11.3077L3.57692 9.84615L4.78846 8.38462L3.82692 7.61539ZM8.48077 7.61539L7.51923 8.38462L8.73077 9.84615L7.51923 11.3077L8.48077 12.0769L10.0192 10.2308L10.3462 9.84615L10.0192 9.46154L8.48077 7.61539Z"
						fill="currentColor" />
				</g>
			}
			<!-- Renew Arrow -->
			@case ('renewArrow') {
				<g>
					<path
						d="M0 7C0 3.13418 2.95294 0 6.86 0C9.66799 0 11.4355 1.60576 12.6 3.0461V0.7C12.6 0.313401 12.9134 0 13.3 0C13.6866 0 14 0.313401 14 0.7V4.2C14 4.56907 13.8739 4.93103 13.6025 5.20247C13.331 5.47392 12.9691 5.6 12.6 5.6H9.1C8.7134 5.6 8.4 5.2866 8.4 4.9C8.4 4.5134 8.7134 4.2 9.1 4.2H11.7266C10.6521 2.80272 9.20218 1.4 6.86 1.4C3.76706 1.4 1.4 3.86582 1.4 7C1.4 10.1237 3.89679 12.6 6.86 12.6C8.46541 12.6 9.9596 11.8568 10.9568 10.7349C11.2137 10.446 11.6561 10.42 11.9451 10.6768C12.234 10.9337 12.26 11.3761 12.0032 11.6651C10.7604 13.0632 8.89459 14 6.86 14C3.10321 14 0 10.8763 0 7Z"
						fill="currentColor" />
				</g>
			}
			<!-- Eye icon -->
			@case ('eyeIcon') {
				<g>
					<path
						d="M10 0C15.5228 0 20 5.625 20 5.625C20 5.625 15.5228 11.25 10 11.25C4.47715 11.25 0 5.625 0 5.625C0 5.625 4.47715 0 10 0ZM10 1.25C7.58375 1.25 5.625 3.20875 5.625 5.625C5.625 8.04125 7.58375 10 10 10C12.4162 10 14.375 8.04125 14.375 5.625C14.375 3.20875 12.4162 1.25 10 1.25ZM10 2.5C11.0355 2.5 11.875 3.89911 11.875 5.625C11.875 7.35089 11.0355 8.75 10 8.75C8.96447 8.75 8.125 7.35089 8.125 5.625C8.125 3.89911 8.96447 2.5 10 2.5Z"
						fill="currentColor" />
				</g>
			}
			<!-- Eye off -->
			@case ('eyeOff') {
				<g>
					<path
						d="M10 0C15.5228 0 20 5.625 20 5.625C20 5.625 15.5228 11.25 10 11.25C4.47715 11.25 0 5.625 0 5.625C0 5.625 4.47715 0 10 0ZM10 2.5C11.0355 2.5 11.875 3.89911 11.875 5.625C11.875 6.5 11.4 7.25 10.8 7.875C10.2 8.5 9.35 8.75 10 8.75C8.96447 8.75 8.125 7.35089 8.125 5.625C8.125 4.35 8.5 3.5 9.2 2.875C9.9 2.25 10.9645 2.5 10 2.5Z"
						fill="currentColor" />
					<!-- Barra diagonal -->
					<line stroke="currentColor" stroke-width="1.5" x1="0" x2="20" y1="0" y2="11.25" />
				</g>
			}
			<!-- Social icons -->
			@case ('socialFacebook') {
				<g>
					<path
						d="m22.25009,12.06246c0,-5.69607 -4.58852,-10.31256 -10.25009,-10.31256c-5.66156,0 -10.25009,4.61649 -10.25009,10.31256c0,5.14817 3.74769,9.4142 8.64852,10.18763l0,-7.20671l-2.60258,0l0,-2.98092l2.60258,0l0,-2.272c0,-2.5842 1.52951,-4.01223 3.87178,-4.01223c1.1211,0 2.29429,0.20141 2.29429,0.20141l0,2.53788l-1.29324,0c-1.27332,0 -1.66968,0.7956 -1.66968,1.61131l0,1.93362l2.8428,0l-0.45446,2.98092l-2.38834,0l0,7.20671c4.90083,-0.77343 8.64852,-5.03946 8.64852,-10.18763z"
						fill="currentColor" />
				</g>
			}
			@case ('socialTwitter') {
				<g>
					<path
						d="M 11.902344 8.464844 L 19.347656 0 L 17.582031 0 L 11.117188 7.347656 L 5.957031 0 L 0 0 L 7.808594 11.113281 L 0 19.988281 L 1.765625 19.988281 L 8.589844 12.226562 L 14.042969 19.988281 L 20 19.988281 Z M 9.484375 11.210938 L 8.695312 10.105469 L 2.398438 1.300781 L 5.109375 1.300781 L 10.191406 8.40625 L 10.980469 9.511719 L 17.585938 18.75 L 14.875 18.75 Z M 9.484375 11.210938 "
						fill="currentColor"
						transform="scale(0.8) translate(4, 5)" />
				</g>
			}
			@case ('socialLinkedIn') {
				<g>
					<path
						d="m5.782 4.155c-1.204 0-1.992.79-1.992 1.829 0 1.016.765 1.83 1.945 1.83h.024c1.227 0 1.991-.814 1.991-1.83-.023-1.039-.764-1.829-1.968-1.829zm14.428 9.619v6.071h-3.519v-5.664c0-1.423-.509-2.394-1.783-2.394-.973 0-1.551.655-1.806 1.288-.093.226-.117.541-.117.858v5.912h-3.52s.047-9.593 0-10.587h3.52v1.501c-.003.005-.007.011-.011.016-.004.006-.008.012-.012.018h.023v-.034c.468-.721 1.303-1.75 3.173-1.75 2.316 0 4.052 1.514 4.052 4.765zm-12.69 6.071h-3.519v-10.587h3.519z"
						fill="currentColor" />
				</g>
			}
			@case ('socialYouTube') {
				<g>
					<path
						d="m19.801 4.267c1.371.078 2.045.281 2.665 1.384.647 1.103.973 3.002.973 6.346v.012c0 3.328-.326 5.241-.971 6.332-.621 1.104-1.294 1.304-2.665 1.397-1.372.079-4.816.126-7.8.126-2.99 0-6.436-.047-7.806-.127-1.368-.093-2.042-.293-2.668-1.397-.639-1.091-.968-3.004-.968-6.333v-.011c0-3.343.329-5.242.968-6.345.626-1.105 1.301-1.306 2.67-1.385 1.368-.092 4.814-.13 7.804-.13 2.984 0 6.428.038 7.798.131zm-3.508 7.733-7.15-4.289v8.579z"
						fill="currentColor" />
				</g>
			}
			@case ('socialInstagram') {
				<g>
					<path
						d="m8.701 4.136h5.898c2.714 0 4.915 2.201 4.915 4.915v5.898c0 2.714-2.201 4.915-4.915 4.915h-5.898c-2.714 0-4.915-2.201-4.915-4.915v-5.898c0-2.714 2.201-4.915 4.915-4.915zm5.9 14.254c1.897 0 3.441-1.543 3.441-3.44v-5.899c0-1.897-1.544-3.44-3.441-3.44h-5.898c-1.897 0-3.441 1.543-3.441 3.44v5.899c0 1.897 1.544 3.44 3.441 3.44zm-6.882-6.39c0-2.171 1.761-3.932 3.932-3.932 2.172 0 3.933 1.761 3.933 3.932 0 2.172-1.761 3.932-3.933 3.932-2.171 0-3.932-1.76-3.932-3.932zm1.476.001c0 1.354 1.103 2.457 2.457 2.457 1.355 0 2.458-1.103 2.458-2.457 0-1.356-1.103-2.458-2.458-2.458-1.354 0-2.457 1.102-2.457 2.458zm7.208-4.228c0 .29-.235.524-.524.524s-.524-.234-.524-.524c0-.289.235-.523.524-.523s.524.234.524.523z"
						fill="currentColor" />
				</g>
			}
			@case ('socialTikTok') {
				<g>
					<path
						d="m12.35132,3.0135c0.87254,-0.0135 1.74009,-0.0055 2.60668,-0.0135c0.0525,1.02055 0.4195,2.06011 1.1665,2.78165c0.7456,0.73954 1.8001,1.07806 2.8262,1.19256l0,2.68465c-0.9616,-0.03151 -1.9276,-0.23152 -2.8002,-0.64554c-0.38,-0.17201 -0.734,-0.39352 -1.0805,-0.62003c-0.0045,1.9481 0.008,3.89371 -0.0125,5.83381c-0.052,0.932 -0.35956,1.8596 -0.90159,2.6276c-0.87204,1.2786 -2.38563,2.1122 -3.94021,2.1382c-0.95355,0.0545 -1.9061,-0.2056 -2.71864,-0.6846c-1.34657,-0.794 -2.29412,-2.2476 -2.43213,-3.8077c-0.016,-0.3335 -0.0215,-0.6665 -0.008,-0.992c0.12,-1.26861 0.74754,-2.48217 1.72159,-3.30772c1.10406,-0.96155 2.65064,-1.41957 4.09872,-1.14856c0.0135,0.98756 -0.026,1.97411 -0.026,2.96166c-0.66154,-0.21401 -1.43458,-0.15401 -2.01261,0.24751c-0.42202,0.27352 -0.74254,0.69254 -0.90955,1.16661c-0.13801,0.338 -0.09851,0.7135 -0.0905,1.0725c0.1585,1.0941 1.21056,2.0136 2.33362,1.9141c0.74454,-0.008 1.45808,-0.44 1.8461,-1.0725c0.1255,-0.2216 0.26601,-0.4481 0.27351,-0.7086c0.06551,-1.1925 0.0395,-2.38011 0.0475,-3.57267c0.00551,-2.68764 -0.008,-5.36779 0.01251,-8.04693l-0.0005,-0.0005z"
						fill="currentColor" />
				</g>
			}
			<!-- Logo -->
			@case ('logo') {
				<g>
					<path
						d="m18.682 32.167 11.114-18.75h13.621l-2.792 4.664h-8.012l-1.348 2.18h8.036l-2.771 4.659h-8.072l-1.601 2.674h8.075l-2.751 4.573zm-9.173-18.75h-4.842v18.75h5.064l2.164-3.221.468 3.221h4.914l11.172-18.75h-5.381l-5.967 9.835-.526-2.991h-4.972l-2.106 2.883z"
						fill="currentColor" />
				</g>
			}
			@case ('logo-48') {
				<g>
					<path
						d="m18.682 32.167 11.114-18.75h13.621l-2.792 4.664h-8.012l-1.348 2.18h8.036l-2.771 4.659h-8.072l-1.601 2.674h8.075l-2.751 4.573zm-9.173-18.75h-4.842v18.75h5.064l2.164-3.221.468 3.221h4.914l11.172-18.75h-5.381l-5.967 9.835-.526-2.991h-4.972l-2.106 2.883z"
						fill="currentColor" />
				</g>
			}
			@case ('logoTypo') {
				<g>
					<path
						d="M42.8961 14.8228H34.8714V16.7945H37.8061V25.8051H40.0989V16.7945H42.8961V14.8228ZM23.9807 14.8228H16.8273V25.8051H23.9234V23.8677H19.0513V21.2998H22.9604V19.328H19.0513V16.7143H23.9234L23.9807 14.8228ZM7.56449 14.8228H0.456909V25.8051H7.56449V23.8677H2.62358V21.2998H6.53274V19.328H2.62358V16.7143H7.50717L7.56449 14.8228ZM12.7003 10.9824L14.8096 0H12.5169L11.1641 9.0679H10.9234L8.95161 0H6.31493L4.34315 9.0679H4.10241L2.7726 0.0114641H0.479833L2.49747 10.9824H5.8793L7.59888 2.62522L9.32992 10.9824H12.7003ZM9.08918 25.8051H15.3828V23.8333H11.3132V14.8228H9.08918V25.8051ZM16.3687 2.24691H18.6615V0.0114641H16.3687V2.24691ZM22.5133 2.24691H24.7373V0.0114641H22.5133V2.24691ZM24.7373 7.27954V3.27866H22.5133V7.3254C22.4756 7.81793 22.2533 8.27806 21.8909 8.61374C21.5285 8.94942 21.0527 9.13591 20.5588 9.13591C20.0648 9.13591 19.589 8.94942 19.2266 8.61374C18.8642 8.27806 18.6419 7.81793 18.6042 7.3254V3.27866H16.3114V7.27954C16.3114 10.0194 17.7558 11.1887 20.4957 11.1887C23.2356 11.1887 24.68 10.0423 24.68 7.27954H24.7373ZM27.7752 14.8228H25.6086V25.8051H27.8326V21.5979L29.3229 21.4259L31.1685 25.8051H33.725L31.2603 20.3369L33.725 14.8228H31.1342L29.3229 19.4885L27.8326 19.649L27.7752 14.8228ZM32.7047 3.65697C32.7047 4.63139 32.2461 5.39947 31.1342 5.39947H29.1394V1.96032H31.1685C31.3951 1.94597 31.622 1.98241 31.8327 2.06696C32.0434 2.15151 32.2326 2.28204 32.3864 2.44902C32.5402 2.61601 32.6547 2.81523 32.7217 3.03214C32.7887 3.24906 32.8064 3.4782 32.7735 3.70282L32.7047 3.65697ZM35.0663 3.70282C35.0663 1.2037 33.7021 0.0917107 31.1915 0.0917107H26.8467V10.9824H29.1394V7.30247H31.2832L32.5786 10.9824H35.0204L33.4613 6.77513C33.9911 6.44339 34.4205 5.97353 34.7033 5.41605C34.986 4.85857 35.1115 4.23456 35.0663 3.61111V3.70282ZM41.4287 1.96032H44.329V0.0114641H36.3043V1.97178H39.2391V10.9824H41.5319L41.4287 1.96032ZM46.6103 16.7143H48.628C49.6941 16.7143 50.2215 17.4136 50.2215 18.4683C50.2215 19.5229 49.7744 20.2222 48.628 20.2222H46.5645L46.6103 16.7143ZM48.628 14.8228H44.3864V25.8051H46.6103V22.1252H48.7541L50.038 25.8051H52.4798L50.9208 21.6094C51.4527 21.2791 51.8843 20.8098 52.1692 20.2522C52.454 19.6947 52.5813 19.0699 52.5372 18.4453C52.5372 15.9347 51.1615 14.8228 48.6624 14.8228H48.628ZM52.2162 10.9938H54.4402V0.0114641H52.2162V4.49383H48.135V0.0114641H45.8423V10.9824H48.135V6.39683H52.2162V10.9938ZM60.8599 20.3827C60.8599 22.9162 60.4128 24.0626 58.5671 24.0626C56.7215 24.0626 56.2744 22.9162 56.2744 20.3827C56.2744 17.8492 56.7215 16.5653 58.5671 16.5653C60.4128 16.5653 60.8599 17.8492 60.8599 20.3827ZM63.1527 20.3827C63.1527 16.6684 62.0063 14.6508 58.5671 14.6508C55.128 14.6508 53.9816 16.6914 53.9816 20.3827C53.9816 24.0741 55.128 26 58.5671 26C62.0063 26 63.1527 24.097 63.1527 20.3827ZM70.0998 25.8051H73.7682V14.8228H71.5557V23.8677H71.3952L68.7356 14.8228H64.9754V25.8051H67.2109V16.7143H67.3714L70.0998 25.8051ZM76.1068 25.8051H78.3423V14.8228H76.1412L76.1068 25.8051ZM86.1033 20.3369L88.4878 14.8228H85.9543L84.1659 19.4885L82.6871 19.649V14.8228H80.3943V25.8051H82.6871V21.5979L84.1659 21.4259L86.0116 25.8051H88.5795L86.1033 20.3369Z"
						fill="currentColor" />
				</g>
			}
			<!-- Default fallback -->
			@default {
				<g>
					<circle cx="12" cy="12" fill="currentColor" r="2" />
				</g>
			}
		}
	</ng-container>
</svg>
